import { IClientTreatmentPlanGoal } from '~/services/api/clientDetails/types';

const filterGoals = (items: IClientTreatmentPlanGoal[]): IClientTreatmentPlanGoal[] =>
  (items?.filter(item => !item.isArchived) || []).map(item => ({
    ...item,
    objectives: item.objectives.filter(objective => !objective.isArchived),
  }));

export default filterGoals;
